export const clearFormInputs = (formSelector) => {
    const $form = (typeof formSelector === 'string' && typeof formSelector !== 'object' ? $(formSelector) : formSelector);

    $form.find('input, textarea').val('');
};

export const updateFieldStatus = (formSelector, field, status) => {
    const $form = (typeof formSelector === 'string' && typeof formSelector !== 'object' ? $(formSelector) : formSelector);
    const fv = $form.data('formValidation');

    fv.updateStatus(field, status);
};

export const revalidateField = (formSelector, field) => {
    const $form = (typeof formSelector === 'string' && typeof formSelector !== 'object' ? $(formSelector) : formSelector);

    $form.formValidation('updateStatus', field, 'NOT_VALIDATED').formValidation('validateField', field);
};

export const resetField = (formSelector, field, resetValue) => {
    const $form = (typeof formSelector === 'string' && typeof formSelector !== 'object' ? $(formSelector) : formSelector);
    const fv = $form.data('formValidation');

    fv.resetField(field, resetValue);
};

export const enableFieldValidators = (formSelector, field) => {
    const $form = (typeof formSelector === 'string' && typeof formSelector !== 'object' ? $(formSelector) : formSelector);

    $form.formValidation('enableFieldValidators', field, true);
};

export const disableFieldValidators = (formSelector, field) => {
    const $form = (typeof formSelector === 'string' && typeof formSelector !== 'object' ? $(formSelector) : formSelector);

    $form.formValidation('enableFieldValidators', field, false);
};

export const setFormLocale = (formSelector, locale) => {
    const $form = (typeof formSelector === 'string' && typeof formSelector !== 'object' ? $(formSelector) : formSelector);

    $form.formValidation('setLocale', locale);
};



// WEBPACK FOOTER //
// ./app/src/js/utils/form.js